"use strict";
// packages/types/src/api/recordCollection.ts
Object.defineProperty(exports, "__esModule", { value: true });
